<template>
  <header class="navbar bg-base-100 border-b border-solid border-base-200 px-10 py-3">
    <div class="flex items-center gap-8">
      <router-link to="/" class="flex items-center gap-4 text-base-content">
        <div class="size-10">
          <img :src="logo" width="40px" height="40px" alt="Logo" class="h-full w-full object-contain" />
        </div>
        <h2 class="text-base-content text-lg font-bold leading-tight tracking-[-0.015em]">
          {{ inmob_data.inmobiliaria_details.nombre }}
        </h2>
      </router-link>
    </div>
    <div class="flex flex-1 justify-end gap-8">
      <div class="flex items-center gap-9">
        <router-link to="/" class="text-base-content hover:text-primary text-sm font-medium leading-normal"
          v-if="inmob_data.home_page_content.is_active">Inicio</router-link>
        <router-link to="/search?propertyType=casa&transactionType=alquiler"
          class="text-base-content hover:text-primary text-sm font-medium leading-normal"
          v-if="inmob_data.search_page_content.is_active">Alquiler</router-link>
        <router-link to="/search?propertyType=casa&transactionType=venta"
          class="text-base-content hover:text-primary text-sm font-medium leading-normal"
          v-if="inmob_data.search_page_content.is_active">Compra</router-link>
        <router-link to="/blog" class="text-base-content hover:text-primary text-sm font-medium leading-normal"
          v-if="inmob_data.blog_page_content.is_active">Blog</router-link>
        <router-link to="/comparison" class="relative text-base-content hover:text-primary text-sm font-medium leading-normal">
          <span>Comparar</span>
          <span v-if="comparisonCount > 0" 
                class="absolute -top-2 -right-2 bg-primary text-primary-content text-xs rounded-full px-1.5 py-0.5 min-w-[1.25rem] text-center">
            {{ comparisonCount }}
          </span>
        </router-link>
        <router-link to="/contact" class="text-base-content hover:text-primary text-sm font-medium leading-normal"
          v-if="inmob_data.contact_page_content.is_active">Contacto</router-link>
      </div>

      <div v-if="!isAuthenticated" class="flex items-center gap-4">
        <router-link to="/login" class="btn btn-ghost min-w-[84px] h-10 px-4 text-sm font-medium leading-normal">
          Iniciar sesión
        </router-link>
        <router-link to="/register"
          class="btn btn-primary min-w-[84px] h-10 px-4 text-sm font-bold leading-normal tracking-[0.015em]">
          Registrarse
        </router-link>
      </div>

      <!-- <button
        class="btn btn-primary min-w-[84px] max-w-[480px] h-10 px-4 text-sm font-bold leading-normal tracking-[0.015em]"
      >
        <span class="truncate">Publicar propiedad</span>
      </button> -->
      <!-- <div
        v-else
        class="avatar"
      >
        <div class="w-10 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2"
          style="
            background-image: url('https://cdn.usegalileo.ai/sdxl10/15ac1c88-f90b-494d-9f39-d993ffdfb372.png');
            background-size: cover;
            background-position: center;
          "
        ></div>
      </div> -->

      <div v-else class="flex items-center">

        <!-- Notificaciones Dropdown -->
        <div class="dropdown dropdown-end mr-4">
          <div tabindex="0" role="button"
            class="relative flex items-center justify-center w-10 h-10 rounded-full hover:bg-base-200 transition-colors"
            title="Notificaciones">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-base-content" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
            <!-- Badge de notificaciones (opcional) -->
            <span v-if="getUser?.notifications?.length"
              class="absolute top-1 right-1 bg-error text-white text-xs rounded-full px-1.5 py-0.5">
              {{ getUser.notifications.length }}
            </span>
          </div>
          <ul tabindex="0"
            class="dropdown-content z-[2] menu p-2 shadow bg-base-100 rounded-box w-80 mt-2 max-h-96 overflow-auto">
            <li v-if="getUser?.notifications?.length">
              <div v-for="(notif, idx) in getUser.notifications" :key="idx"
                class="py-2 px-2 border-b border-base-200 last:border-b-0">
                <div class="font-medium text-base-content">{{ notif.title }}</div>
                <div class="text-xs text-base-content/70">{{ notif.body }}</div>
                <div class="text-xs text-base-content/40 mt-1">{{ notif.date }}</div>
              </div>
            </li>
            <li v-else>
              <span class="text-base-content/60 text-sm py-4 block text-center">No tienes notificaciones</span>
            </li>
          </ul>
        </div>

        <div class="dropdown dropdown-end">
          <div tabindex="0" role="button"
            class="w-10 h-10 rounded-full bg-primary text-primary flex items-center justify-center font-bold text-lg uppercase ring ring-primary ring-offset-base-100 ring-offset-2 border-primary border border-black select-none"
            :title="getUser?.name + ' ' + getUser?.lastname">
            {{ getUser?.name?.charAt(0) }}{{ getUser?.lastname?.charAt(0) }}
          </div>
          <ul tabindex="0" class="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box w-52 mt-2">
            <li>
              <router-link to="/account/profile">Perfil</router-link>
            </li>
            <li>
              <router-link to="/account/favorites">Mis favoritos</router-link>
            </li>
            <li>
              <router-link to="/account/mi-rent">Mi alquiler</router-link>
            </li>
            <li>
              <button @click="$store.dispatch('auth/logout')">Cerrar sesión</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState({
      inmob_data: state => state.inmob_data,
    }),
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getUser: 'auth/getUser',
      comparisonCount: 'comparison/comparisonCount'
    }),
    logo() {
      return `${process.env.VUE_APP_API_BASE_URL}${this.inmob_data.inmobiliaria_details.logo}`;
    }
  },
};
</script>
